import { MessageChannel } from "@prisma/client";
import { useQuery } from "@tanstack/react-query";
import { getMessageSequenceSummary } from "@/app/actions/messages-content/steps/action";
import { QueryKey } from "@/app/vars/QueryKeys";

type Options = {
  objectiveId?: number;
  channel: MessageChannel;
  enabled?: boolean;
};

export function buildSequenceSummaryQueryKey(objectiveId: number, channel: MessageChannel) {
  return [QueryKey.MESSAGE_SEQUENCE, "summary", objectiveId, channel];
}

export function useFetchMessageSequenceSummary(options: Options) {
  const { objectiveId, channel, enabled = true } = options;

  return useQuery({
    queryKey: [QueryKey.MESSAGE_SEQUENCE, "summary", objectiveId, channel],
    queryFn: () => getMessageSequenceSummary(objectiveId!, channel),
    enabled: enabled && !!objectiveId,
    staleTime: Infinity,
  });
}
